import { NavLink } from 'react-router-dom';
import {
  Code,
  Chats,
  Toolbox,
  XSquare,
  SignOut,
  UserCircle,
  UserGear,
  Dna,
  ClipboardText,
} from '@phosphor-icons/react';
import { useAuth } from '@Context/CognitoAuthProvider';
import { jwtDecode } from 'jwt-decode';
import { CognitoIDToken } from '@Models/types';

interface NavlinksMobileProps {
  closeMenu: () => void;
}

const NavlinksMobile: React.FC<NavlinksMobileProps> = ({ closeMenu }) => {
  const { user, logout } = useAuth();
  const logoutUser = async () => {
    await logout();
    closeMenu();
  };
  const isAdmin = user?.admin ?? false;
  const username = user?.profile?.email;
  const decode = jwtDecode(
    localStorage.getItem('idToken') || ''
  ) as CognitoIDToken;
  const name = decode.given_name;

  return (
    <div className="fixed inset-0 z-50 flex justify-end bg-black bg-opacity-50">
      <div className="relative flex h-auto w-64 flex-col justify-between rounded-lg bg-white p-4 shadow-lg">
        <div>
          <div className="flex items-center justify-between pt-11">
            <button
              className="absolute right-4 top-4 z-50 text-brandRed-500"
              onClick={closeMenu}
            >
              <XSquare size={35} weight="fill" />
            </button>
          </div>
          <NavLink
            to="/home"
            className={({ isActive }) =>
              `block px-4 py-2 ${isActive ? 'rounded bg-primary-700 text-white' : 'text-gray-800'}`
            }
            onClick={closeMenu}
          >
            <div className="flex items-center gap-2">
              <Code size={20} weight="bold" />
              <span>Generator</span>
            </div>
          </NavLink>
          <NavLink
            to="/gpt"
            className={({ isActive }) =>
              `block px-4 py-2 ${isActive ? 'rounded bg-primary-700 text-white' : 'text-gray-800'}`
            }
            onClick={closeMenu}
          >
            <div className="flex items-center gap-2">
              <Chats size={20} weight="bold" />
              <span>GPT</span>
            </div>
          </NavLink>
          <NavLink
            to="/prompts"
            className={({ isActive }) =>
              `block px-4 py-2 ${isActive ? 'rounded bg-primary-700 text-white' : 'text-gray-800'}`
            }
            onClick={closeMenu}
          >
            <div className="flex items-center gap-2">
              <Toolbox size={20} weight="bold" />
              <span>Prompts</span>
            </div>
          </NavLink>
          {isAdmin && !!user?.profile?.jira_api_key && (
            <>
              <NavLink
                to="/analyzer"
                className={({ isActive }) =>
                  `block px-4 py-2 ${
                    isActive
                      ? 'rounded bg-primary-700 text-white'
                      : 'text-gray-800'
                  }`
                }
                onClick={closeMenu}
              >
                <div className="flex items-center gap-2">
                  <Dna size={20} weight="bold" />
                  <span>Analyzer</span>
                </div>
              </NavLink>
            </>
          )}

          <NavLink
            to="/analyzer-reports"
            className={({ isActive }) =>
              `block px-4 py-2 ${
                isActive ? 'rounded bg-primary-700 text-white' : 'text-gray-800'
              }`
            }
            onClick={closeMenu}
          >
            <div className="flex items-center gap-2">
              <ClipboardText size={20} weight="bold" />
              <span>Analyzer Reports</span>
            </div>
          </NavLink>

          <NavLink
            to="/profile"
            className={({ isActive }) =>
              `block px-4 py-2 ${isActive ? 'rounded bg-primary-700 text-white' : 'text-gray-800'}`
            }
            onClick={closeMenu}
          >
            <div className="flex items-center gap-2">
              <UserGear size={20} weight="bold" />
              <span>Manage Account</span>
            </div>
          </NavLink>

          <span onClick={logoutUser} className="block px-4 py-2 text-gray-800">
            <div className="flex items-center gap-2">
              <SignOut size={20} weight="bold" />
              <span>Sign Out</span>
            </div>
          </span>
        </div>

        <div className="mt-4 flex flex-row items-center justify-center gap-2 pb-2">
          <UserCircle size={45} weight="thin" />
          <div className="flex flex-col">
            <span className="font-bold text-neutral-700">{name}</span>
            <span className="text-xs text-primary-600">{username}</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NavlinksMobile;
